import formAppWebConfig from './formAppWebConfig';
import tableAppDomains from './tableAppDomains';
import formAppWebDns from './tableAppDomains';

export default {
  title: 'Domains',
  attributeName: 'appDomains',
  getURL: 'appId/areaId/appDomainsPlay',
  createURL: 'appId/areaId/appDomainsPlay',
  updateURL: 'appId/areaId/appDomainsPlay',
  removeURL: 'appId/areaId/appDomainsPlay',
  sessionParams: ['appId', 'areaId'],
  tableConfig: tableAppDomains,
  removeNameField:'dns',
  removeText:'You are about to remove the Domain with DNS  ##dns##.',
  autoUpdate: true,
  // formConfig: [
  //   formAppWebDns,
  // ],
};
